import React, { useEffect, useState } from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Swiper, SwiperSlide } from "swiper/react"
import { Autoplay, Navigation } from "swiper/modules"
import {
  faBars,
  faTimes,
} from "@fortawesome/free-solid-svg-icons"
import { StaticImage } from "gatsby-plugin-image"
import "swiper/css"
import { Container, Row, Col } from "react-bootstrap"
import * as styles from "./Header.module.css"
import { graphql, Link, useStaticQuery } from "gatsby"
import SearchBar from "./SearchBar"

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false)
  const [searchVisible, setSearchVisible] = useState(false)  
  const data = useStaticQuery(graphql`
    query {
      wpMenu(name: { eq: "Menu 1" }) {
        menuItems {
          nodes {
            id
            label
            url
            childItems {
              nodes {
                label
                url
              }
            }
            parentId
          }
        }
      }
      allWpEvent {
        nodes {
          aCFevent {
            endDate
            date
            citySelector {
              nodes {
                ... on WpCity {
                  aCFcity {
                    location
                  }
                }
              }
            }
          }
          uri
          title
        }
      }
    }
  `)
  const menuItems = data?.wpMenu?.menuItems?.nodes || []
  useEffect(() => {
    const tagManagerScript = document.createElement("script")
    tagManagerScript.async = true
    tagManagerScript.src =
      "https://www.googletagmanager.com/gtm.js?id=GTM-WRRPS3V"
    document.head.appendChild(tagManagerScript)
    return () => {
      document.head.removeChild(tagManagerScript)
    }
  }, [])

  // Today's date
  const today = new Date();

  // Process events
  const events = data.allWpEvent.nodes
    .map(event => {
      const endDate = new Date(event.aCFevent.endDate);
      return { ...event, parsedEndDate: endDate };
    })
    .filter(event => event.parsedEndDate >= today)
    .sort((a, b) => a.parsedEndDate - b.parsedEndDate)
    .slice(0, 5);
  
  const swiperSettings = {
    className: "w-100",
    loop: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev"
    },
    slidesPerView: 1,
    modules: [Autoplay, Navigation],
  }
  const toggleMenu = () => {
    setMenuOpen(!menuOpen)
  }
  const toggleSearch = () => {
    setSearchVisible(!searchVisible) // Toggle search form visibility
  }
  const [expandedItems, setExpandedItems] = useState({})

  const toggleItem = itemId => {
    setExpandedItems(prev => ({
      ...prev,
      [itemId]: !prev[itemId],
    }))
    console.log(itemId)
  }
  return (
    <>
      <div
        className={`${styles.burgerIcon} d-md-none ${
          menuOpen ? "d-none" : "d-block"
        }`}
      >
        <FontAwesomeIcon
          icon={menuOpen ? faTimes : faBars}
          onClick={toggleMenu}
          style={{ fontSize: "1rem" }}
        />
      </div>
      <div
        className={`${styles.mobileMenu} ${
          menuOpen ? styles.mobileMenuOpen : ""
        }`}
      >
        <ul>
          <li className="text-capitalize">
            <a href="#" className={`${styles.subMenuLink} bg-black p-2`}>
              <span>Menu</span>
              <FontAwesomeIcon icon={faTimes} onClick={toggleMenu} size="1x" />
            </a>
          </li>

          {/* Dynamic list of menu items */}
          {menuItems &&
            menuItems.map(
              (item, index) =>
                item.parentId === null && (
                  <li key={index}>
                    <a
                      href={expandedItems[item.id] ? item.url : "#"}
                      onClick={e => {
                        if (!expandedItems[item.id]) {
                          e.preventDefault() // Prevent navigation before expanding
                          toggleItem(item.id)
                        }
                      }}
                      className={styles.subMenuLink}
                    >
                      <span className="text-capitalize">{item.label}</span>
                      <StaticImage
                        src="../images/white-rt-arrow.png"
                        width={18}
                        height={10}
                        className="mt-1 mx-1"
                        alt="Arrow Icon"
                      />
                    </a>
                    <ul className={styles.subMenu}>
                      {expandedItems[item.id] &&
                        item?.childItems?.nodes?.map((subItem, subIndex) => (
                          <li key={subIndex}>
                            <a href={subItem?.url}>{subItem?.label}</a>
                            <StaticImage
                              src="../images/white-rt-arrow.png"
                              width={18}
                              height={12}
                              className="mt-1"
                              alt="Arrow Icon"
                            />
                          </li>
                        ))}
                    </ul>
                  </li>
                ),
            )}
        </ul>
      </div>

      <nav className={`${styles.navContainer} position-fixed nav-header `}>
        <Container fluid>
          <Row>
            <Col md={12}>
              <div className="site-tp-nav-bar">
                <div className="menu-menu-1-container">
                  <ul
                    id="menu-menu-2"
                    className={`${styles.pHeaderBigger} menu d-flex`}
                  >
                    {menuItems &&
                      menuItems?.map(
                        (item, index) =>
                          item.parentId === null && (
                            <li key={index} className="text-capitalize mb-0">
                              <a
                                href={item?.url}
                                className="text-decoration-none"
                              >
                                {item?.label !== "Mission"
                                  ? item?.label
                                  : "Millenium Mission"}
                              </a>
                              {item?.childItems?.nodes.length > 0 && (
                                <ul className="sub-menu z-3">
                                  {item?.childItems?.nodes.map(
                                    (subItem, subIndex) => (
                                      <li key={subIndex} className="mb-0">
                                        <a
                                          href={subItem.url}
                                          className="text-decoration-none"
                                        >
                                          {subItem.label}
                                        </a>
                                      </li>
                                    ),
                                  )}
                                </ul>
                              )}
                            </li>
                          ),
                      )}
                  </ul>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </nav>

      <header className={`${styles.headerTop} header-top`}>
        <Container fluid className="h-100">
          <Row className="h-100">
            <Col md={2} className="head-col-1">
              <span className="brand mt-2 md-mt-0">
                <a href="/">
                  <StaticImage
                    src="../images/Standard-Logo-for-Website-Header.png"
                    alt="Brand Logo"
                    placeholder="blurred"
                  />
                </a>
              </span>
            </Col>

            <Col md={10} className={styles.listMenuContainer}>
              <Row className={styles.listMenu}>
                <Col md={8} className="head-col-3 md-mt-0">
                  <div
                    className={`${styles.upcomingSlideHeadMobile} h-100 upcoming-slide-head`}
                  >
                    <div className={`${styles.widthUpcoming} upcoming-title`}>
                      <Link to="/assemblies" className="text-decoration-none">
                        Upcoming Assemblies
                      </Link>
                    </div>
                    <Swiper {...swiperSettings}>
                      {events &&
                        events?.map((item, index) => (
                          <SwiperSlide key={index}>
                            <div className="item swiper-slide h-75">
                              <ul
                                className={`${styles.topMenuList} top-menu-list`}
                              >
                                <li className="mb-0">{item.aCFevent.date}</li>
                              </ul>
                              <div className="digital-market-sec row">
                                <Col className="col-md-12 pb-1">
                                  <span className="digital-market-text">
                                    <a
                                      href={item.uri}
                                      className="text-decoration-none"
                                    >
                                      {item.title}
                                    </a>
                                  </span>
                                </Col>
                              </div>
                            </div>
                          </SwiperSlide>
                        ))}

                      <div
                        className={`${styles.swiperButtonNav} swiper-btn-nav w-center-slide-arrow`}
                      >
                        <div
                          className={`${styles.swiperButtonPrev} swiper-button-prev`}
                        >
                          <StaticImage
                            src="../images/prev-arrow.png"
                            alt="Prev"
                            className="ar-23"
                          />
                        </div>
                        <div
                          className={`${styles.swiperButtonNext} swiper-button-next`}
                        >
                          <StaticImage
                            src="../images/next-arrow.png"
                            alt="Next"
                            className="ar-23"
                          />
                        </div>
                      </div>
                    </Swiper>
                  </div>
                </Col>

                <Col md={4} className="head-col-4">
                  <div className="rt-social-head align-items-end">
                    <a
                      href="tel:2122569890"
                      className="tel-no text-decoration-none"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 512 512"
                        className={styles.iconSocial}
                      >
                        <path d="M164.9 24.6c-7.7-18.6-28-28.5-47.4-23.2l-88 24C12.1 30.2 0 46 0 64C0 311.4 200.6 512 448 512c18 0 33.8-12.1 38.6-29.5l24-88c5.3-19.4-4.6-39.7-23.2-47.4l-96-40c-16.3-6.8-35.2-2.1-46.3 11.6L304.7 368C234.3 334.7 177.3 277.7 144 207.3L193.3 167c13.7-11.2 18.4-30 11.6-46.3l-40-96z" />
                      </svg>{" "}
                      <span className="mx-1"> 212-256-9890</span>
                    </a>
                    <ul className={`${styles.menuIcons} social-media md:pt-3`}>
                      <li>
                        <a
                          href="https://www.linkedin.com/company/the-millennium-alliance"
                          target="_blank"
                          rel="noopener noreferrer"
                          aria-label="linkedin link"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 448 512"
                            className={styles.iconSocial}
                          >
                            <path d="M100.3 448H7.4V148.9h92.9zM53.8 108.1C24.1 108.1 0 83.5 0 53.8a53.8 53.8 0 0 1 107.6 0c0 29.7-24.1 54.3-53.8 54.3zM447.9 448h-92.7V302.4c0-34.7-.7-79.2-48.3-79.2-48.3 0-55.7 37.7-55.7 76.7V448h-92.8V148.9h89.1v40.8h1.3c12.4-23.5 42.7-48.3 87.9-48.3 94 0 111.3 61.9 111.3 142.3V448z" />
                          </svg>
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://twitter.com/Mill_All"
                          target="_blank"
                          rel="noopener noreferrer"
                          aria-label="twitter link"
                        >
                          <svg
                            className={styles.iconSocialX}
                            width="14"
                            height="14"
                            viewBox="0 0 14 14"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M8.15281 5.92812L13.2525 0H12.0439L7.616 5.14719L4.07925 0H0L5.34822 7.78356L0 14H1.20859L5.88481 8.56439L9.61975 14H13.699L8.15248 5.92812H8.15281ZM6.49753 7.85203L5.95558 7.077L1.64402 0.909781H3.50033L6.97966 5.887L7.5215 6.66203L12.0445 13.1316H10.1884L6.49753 7.85236V7.85203Z"
                              fill="white"
                            ></path>
                          </svg>
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://www.youtube.com/channel/UCJgFlsBHBF2u7Dl28seltUA"
                          target="_blank"
                          rel="noopener noreferrer"
                          aria-label="youtube link"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 576 512"
                            className={styles.iconSocial}
                          >
                            <path d="M549.7 124.1c-6.3-23.7-24.8-42.3-48.3-48.6C458.8 64 288 64 288 64S117.2 64 74.6 75.5c-23.5 6.3-42 24.9-48.3 48.6-11.4 42.9-11.4 132.3-11.4 132.3s0 89.4 11.4 132.3c6.3 23.7 24.8 41.5 48.3 47.8C117.2 448 288 448 288 448s170.8 0 213.4-11.5c23.5-6.3 42-24.2 48.3-47.8 11.4-42.9 11.4-132.3 11.4-132.3s0-89.4-11.4-132.3zm-317.5 213.5V175.2l142.7 81.2-142.7 81.2z" />
                          </svg>
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://www.facebook.com/MillenniumAlliance"
                          target="_blank"
                          rel="noopener noreferrer"
                          aria-label="facebook link"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 320 512"
                            className={styles.iconSocial}
                          >
                            <path d="M80 299.3V512H196V299.3h86.5l18-97.8H196V166.9c0-51.7 20.3-71.5 72.7-71.5c16.3 0 29.4 .4 37 1.2V7.9C291.4 4 256.4 0 236.2 0C129.3 0 80 50.5 80 159.4v42.1H14v97.8H80z" />
                          </svg>
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://www.instagram.com/millennium_alliance/"
                          target="_blank"
                          rel="noopener noreferrer"
                          aria-label="instagram link"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 448 512"
                            className={styles.iconSocial}
                          >
                            <path d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z" />
                          </svg>
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://www.tiktok.com/@mill_all"
                          target="_blank"
                          rel="noopener noreferrer"
                          aria-label="tiktok link"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 448 512"
                            className={styles.iconSocial}
                          >
                            <path d="M448 209.9a210.1 210.1 0 0 1 -122.8-39.3V349.4A162.6 162.6 0 1 1 185 188.3V278.2a74.6 74.6 0 1 0 52.2 71.2V0l88 0a121.2 121.2 0 0 0 1.9 22.2h0A122.2 122.2 0 0 0 381 102.4a121.4 121.4 0 0 0 67 20.1z" />
                          </svg>
                        </a>
                      </li>
                      <li>
                        <svg xmlns="http://www.w3.org/2000/svg"
                             viewBox="0 0 512 512"
                             className={styles.iconSocial}
                             style={{
                               color: "#000",
                               fill: "#000",
                               cursor: "pointer",
                             }}
                             onClick={toggleSearch}>
                          <path
                            d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z" />
                        </svg>
                      </li>
                    </ul>
                  </div>
                  <div
                    className={`${
                      searchVisible ? "d-block opacity-100" : ""
                    } form-group rt-tp-hd-searh-bar`}
                  >
                    <SearchBar />
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </header>
    </>
  )
}

export default Header
